import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { Text, Box, Flex } from '@chakra-ui/react'

import { isEmpty } from 'src/utils/helpers'
import intlMessagesApp from 'src/modules/App/translations'
import intlMessages from 'src/modules/Inventory/translations'
import withToast from 'src/components/Toast'
import { Input } from 'src/components/Form'
import Button from 'src/components/Button/Button'
import { Form, Field } from 'react-final-form'

class GroupRename extends Component {
  static contextTypes = {
    router: PropTypes.object,
  }

  state = {
    name: this.props.group.name,
  }

  componentDidUpdate(prevProps) {
    const { intl, saveGroupResponse, onClose, toast } = this.props

    // If there is save response and it changed (it's empty object while submitting)
    if (!isEmpty(saveGroupResponse) && saveGroupResponse !== prevProps.saveGroupResponse) {
      if (saveGroupResponse.success) {
        toast({
          title: intl.formatMessage(intlMessagesApp.appSuccessTitle),
          description: intl.formatMessage(intlMessages.inventoryGroupSaveSuccess),
          status: 'success',
        })

        onClose()
      } else {
        toast({
          title: intl.formatMessage(intlMessagesApp.appErrorTitle),
          description:
            saveGroupResponse.message || intl.formatMessage(intlMessagesApp.appErrorDescription),
          status: 'error',
        })
      }
    }
  }

  handleSubmit = values => {
    const { group, inventoryGroupSave } = this.props
    // Submit through redux
    inventoryGroupSave({
      id: group.id,
      name: values.name,
    })
  }

  validateForm = values => {
    const { intl } = this.props

    const errors = {}

    if (!values.name) {
      errors.name = intl.formatMessage(intlMessages.inventoryValidationRoom)
    }
    if (values && values.length > 75) {
      errors.name = intl.formatMessage(intlMessages.inventoryValidationRoomLength)
    }

    return errors
  }

  render() {
    const { intl, onClose, group } = this.props

    return (
      <Form
        onSubmit={this.handleSubmit}
        validate={this.validateForm}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Field
              name='name'
              initialValue={group.name}
              render={({ input, meta }) => (
                <Box my={'8px'}>
                  <Input
                    name='name'
                    placeholder={intl.formatMessage(intlMessages.inventoryPlaceholderRoomNewName)}
                    error={meta}
                    type='text'
                    {...input}
                  />
                </Box>
              )}
            />

            <Flex align={'center'} justify={'space-between'} mt={'24px'}>
              <Button isFullWidth mr={'12px'} onClick={onClose} variant='outline'>
                <Text color='text.primary'>Close</Text>
              </Button>
              <Button isFullWidth onClick={handleSubmit}>
                {intl.formatMessage(intlMessagesApp.appGlobalRename)}
              </Button>
            </Flex>
          </form>
        )}
      />
    )
  }
}

GroupRename.propTypes = {
  group: PropTypes.object.isRequired,
  isSaveGroupInProgress: PropTypes.bool.isRequired,
  saveGroupResponse: PropTypes.object.isRequired,
  inventoryGroupSave: PropTypes.func.isRequired,
  intl: PropTypes.object,
  router: PropTypes.object,
}

export default injectIntl(withToast(GroupRename))
